import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import combineStyles from '../../../helpers/combineStyles';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import SpacingStyles from '../../../styles/helpers/spacing';
import ListsStyle from '../__styles__/Lists.style';
import classnames from 'classnames';
import { Formik } from 'formik';
import { Grid } from '@material-ui/core';
import GridItem from '../../shared/GridItem';
import OutlinedTextField from '../../shared/Fields/OutlinedTextField';
import CheckboxInput from '../../shared/Inputs/Checkbox';
import Button from '@material-ui/core/Button';
import ProgressButton from '../../shared/Buttons/ProgressButton';
import ActivityIndicator from '../../shared/ActivityIndicator';
import { history } from '../../../helpers/history';

export class PermissionEdit extends Component {
  componentDidMount() {
    this.props.fetchRoles();
    this.props.fetchPermission(this.props.match.params.id);
  }

  handleOnSave = async (permissionId, permission) => {
    const { editPermission } = this.props;
    const { description, roles } = permission;
    editPermission(permissionId, {
      rolesIds: roles,
      description
    });
  };

  render() {
    const {
      classes,
      serverErrors,
      permission = {},
      roles,
      isSubmitting
    } = this.props;

    if (!roles.length || !permission.id) {
      return <ActivityIndicator />;
    }

    const rolesPermission = permission.roles || [];
    const initialValues = {
      description: permission.description || '',
      roles: rolesPermission.map(({ id }) => Number(id))
    };
    return (
      <section className={classes.headerRoot}>
        <div className={classes.permission}>
          <h1 className={classnames(classes.headline5)}>{'Editar Permiso'}</h1>
        </div>

        <div className={classes.permission}>
          <Formik
            ref={ref => (this.formik = ref)}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={initialValues}
            onSubmit={values => {
              this.handleOnSave(permission.id, values);
            }}
            onReset={(values, actions) => {
              actions.resetForm();
              history.replace(`/permissions`);
            }}
            render={({
              values,
              touched,
              errors,
              handleChange,
              handleSubmit,
              handleReset,
              dirty
            }) => (
              <Grid container spacing={16}>
                <GridItem xs={12}>
                  <OutlinedTextField
                    name="description"
                    onChange={handleChange}
                    className={classes.formControl}
                    value={values.description}
                    label={'Descripción'}
                    fullWidth
                    error={
                      (touched.description && !!errors.description) ||
                      (serverErrors && !!serverErrors.description)
                    }
                    helperText={
                      (touched.description && errors.description) ||
                      (serverErrors &&
                        serverErrors.description &&
                        serverErrors.description)
                    }
                  />
                </GridItem>
                <GridItem xs={12}>
                  <h4 className={classes.rolesTitle}>Roles</h4>
                  <div className={classes.rolesContainer}>
                    {roles.map((role, index) => (
                      <div key={role.id} className={classes.roleItem}>
                        <span className={classes.roleIndex}>{index + 1}.</span>
                        <CheckboxInput
                          classes={{
                            root: classnames(
                              classes.noMarginTop,
                              classes.checkboxContainer
                            )
                          }}
                          name="roles"
                          value={values.roles.includes(+role.id)}
                          label={role.displayName}
                          onChange={e => {
                            const { value } = e.target;
                            const newRoles = value
                              ? [...values.roles, +role.id]
                              : values.roles.filter(r => r !== +role.id);

                            handleChange({
                              target: {
                                name: 'roles',
                                value: newRoles
                              }
                            });
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </GridItem>

                <GridItem xs={12}>
                  <div className={classes.buttonsContainer}>
                    <Button
                      className={classes.button}
                      onClick={handleReset}
                      color={'secondary'}
                      classes={{ label: classes.buttonLabel }}
                    >
                      {'Regresar'}
                    </Button>
                    <ProgressButton
                      onClick={handleSubmit}
                      className={classes.button}
                      classes={{
                        disabled: classes.buttonDisabled,
                        label: classes.buttonLabel
                      }}
                      color={'secondary'}
                      variant="contained"
                      disabled={!dirty || isSubmitting}
                      isSubmitting={isSubmitting}
                    >
                      {'Enviar'}
                    </ProgressButton>
                  </div>
                </GridItem>
              </Grid>
            )}
          />
        </div>
      </section>
    );
  }
}

const styles = theme => ({
  headerRoot: {
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    width: '100%'
  },
  permission: {
    alignItems: 'center',
    display: 'flex',
    minHeight: 84,
    flexWrap: 'wrap',
    padding: [[0, theme.spacing.unit * 3]],
    position: 'relative',
    '&:first-child': {
      borderBottom: '1px solid rgba(12,31,44,0.12)'
    }
  },
  backButton: {
    position: 'absolute',
    left: 16
  },
  error: {
    backgroundColor: '#FDE5E2',
    color: ['#F22D12', '!important']
  },
  root: {
    backgroundColor: '#FFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    padding: theme.spacing.unit * 4,
    width: '100%',
    marginBottom: '10px'
  },
  headerSection: {
    flex: 1,
    paddingBottom: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 4,
    borderBottom: '1px solid rgba(0,0,0,0.12)'
  },
  bodySection: {
    display: 'flex',
    flex: 1
  },
  rolesTitle: {
    marginBottom: '8px',
    color: '#333'
  },
  rolesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  roleItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    height: '40px'
  },
  roleIndex: {
    fontSize: '0.85rem',
    fontWeight: 'bold',
    color: '#555',
    marginRight: '6px',
    width: '20px'
  },
  buttonsContainer: {
    display: 'flex'
  }
});

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    styles
  )
)(PermissionEdit);
